import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Task } from "@common/types/task";
import { TaskStatusSelect } from "@components/tasks/TaskStatusSelect/TaskStatusSelect";
import { TaskStatus as TaskStatusIcon } from "@components/tasks/TaskStatusSelect/TaskStatus";
import { TASK_STATUS_CONFIG } from "@components/tasks/TaskStatusSelect/taskStatus.constants";
import { Picker } from "@design-system/Picker/Picker.lib";
import { memo, useMemo } from "react";
import { CaptureClicks } from "@design-system/CaptureClicks/CaptureClicks";
import { TaskStatusTerminationConfirmationModal } from "@components/tasks/TaskStatusTerminationConfirmationModal";
import { useTaskStatusChange } from "@components/tasks/useTaskStatusChange";
import { NestedTaskRow } from "../../types";

export const StatusCell: React.FC<
    CellContext<ViewTableFeatures, NestedTaskRow, string>
> = memo((props) => {
    const task = props.row.original as Task;
    const status = props.row.original.status;
    const { handleStatusChange, confirmation } = useTaskStatusChange(task);

    const trigger = useMemo(
        () => (
            <Picker.CellContent
                addText="Set status"
                hideAddIcon
                value={
                    status ? (
                        <TaskStatusIcon status={status} showText />
                    ) : undefined
                }
                aria-label={
                    status ? TASK_STATUS_CONFIG[status].tooltip : undefined
                }
            />
        ),
        [status],
    );

    if (props.row.original.isGroup || props.row.original.isNewPlaceholder) {
        return null;
    }

    return (
        <>
            <ViewTableCell>
                <CaptureClicks>
                    <TaskStatusSelect
                        value={status}
                        trigger={trigger}
                        onValueChange={handleStatusChange}
                    />
                </CaptureClicks>
            </ViewTableCell>
            <TaskStatusTerminationConfirmationModal {...confirmation} />
        </>
    );
});
